export const config = {
  use_live_camera: true,
  resolution: "1920 x 1080",
  console_log: true,
  "are-you-there-timer-in-seconds": 600,
};
